module.exports = __webpack_public_path__ + "img/asus-zenfone-4-selfie.53ffd723.jpg";